export default __webpack_public_path__ + "static/media/vip4_left.8ffc83d7.webp";